<template>
  <div>
    <Step1 :rowId="fissionId" v-if="index === 0" @cancel="cancel" @nextStep="nextStep"></Step1>
    <Step2 :rowId="fissionId" v-if="index === 1" @lastStep="lastStep" @nextStep="nextStep"></Step2>
    <Step3 :rowId="fissionId" :layoutList="layoutList" v-if="index === 2" @lastStep="lastStep"
           @nextStep="nextStep"></Step3>
    <Step4 :rowId="fissionId" v-if="index === 3" @lastStep="lastStep" @saved="saved"></Step4>
  </div>
</template>

<script>
import Step1 from './detail/step1'
import Step2 from './detail/step2'
import Step3 from './detail/step3'
import Step4 from './detail/step4'
import {dataApi} from "@/services/operate/marketingFission";

/**
 * 表单组件
 */
export default {
  components: {
    Step1, Step2, Step3, Step4
  },
  props: ['rowId'],
  data() {
    return {
      index: 0,
      fissionId: this.rowId,
      layoutList: []
    }
  },
  mounted() {
  },
  methods: {
    async getData() {
      await dataApi.getFormDetail(this.rowId).then(res => {
        if (res.data) {
          this.layoutList = res.data.layoutList
        }
        this.index = 2
      })
    },
    cancel() {
      this.$emit('cancelled')
    },
    saved() {
      this.$emit('saved')
    },
    nextStep(id) {
      this.fissionId = id
      if (this.index === 1) {
        this.getData()
      } else {
        this.index++
      }
    },
    lastStep() {
      if (this.index === 3) {
        this.getData()
      } else {
        this.index--
      }
    }
  }
};
</script>
